import {
  DashboardUseCase as EdgeDashboardUseCase,
  Scope as EdgeScope,
  Status as EdgeStatus,
  Status,
} from 'generated/graphql';
import { DashboardUseCase } from 'v2/core/entities/dashboardUseCase';
import { Scope } from 'v2/core/entities/scope';

export const mapToScope = (scope: Scope): EdgeScope => {
  switch (scope) {
    case Scope.PRIVATE:
      return EdgeScope.Private;
    case Scope.PUBLIC:
      return EdgeScope.Public;
    case Scope.PUBLIC_EDITABLE:
      return EdgeScope.PublicEditable;
    case Scope.HIDDEN:
      return EdgeScope.Hidden;
    case Scope.SNAPSHOT:
      return EdgeScope.Snapshot;
    case Scope.SYSTEM_GENERATED:
      return EdgeScope.SystemGenerated;
  }
};

export const mapToDashboardUseCase = (
  useCase?: DashboardUseCase,
): EdgeDashboardUseCase => {
  switch (useCase) {
    case DashboardUseCase.Search:
      return EdgeDashboardUseCase.Search;
    default:
      return EdgeDashboardUseCase.Default;
  }
};

export const mapToStatus = (scope: Status): EdgeStatus => {
  switch (scope) {
    case Status.Invalid:
      return EdgeStatus.Invalid;
    case Status.Archived:
      return EdgeStatus.Archived;
    case Status.Unarchived:
      return EdgeStatus.Unarchived;
  }
};
